import React from "react";
import API from "@beardeddevops/react.api";
import {freshdeskTicketDisplay} from "utils/freshdeskTicket";
import Framework from "@beardeddevops/react.framework"
import {Types} from "components/index";
import GoogleMapReact from "google-map-react";
import PinDrop from "@material-ui/icons/PinDrop"
import {Call_Geocode_API} from "../../constants/Utilities";
import {getGoogleMapBootstrapURLKeys} from "../../constants/GoogleMaps";
/**
 *  @property {Tickets_Object} state
 *  @property {object} model
 *  @property {Tickets_Properties} model.properties
 *  @property {Tickets_Is} model.is
 *  @property {Tickets_Has} model.has
 */

const PinLocation = ({text}) => {
	return (
		<div style={{textAlign: 'center', width: '40px', fontSize: '20px'}}>
			<PinDrop fontSize={'small'}/><br/>
			<span style={{fontSize: '10px', lineHeight: '12px', display: 'inline-block', fontWeight: 'bold'}}>{text}</span>
		</div>
	);
};

export default class ScheduleMap extends Framework.Components.Collection {
	constructor(props) {
		super(props, Types.Tickets._name);

		this.state.tickets = [];

		this.state.name = this.props.name || '';

		this.state.latitude = 37.1867970;
		this.state.longitude = -93.2928740;
		this.state.center = null;
		this.state.defaultCenter = {
			lat: 37.1867970,
			lng: -93.2928740
		};

		this.state.field_engineer = this.props.field_engineer || '';
		this.state.field_engineer_error = '';

		this.state.selected_date = this.props.selected_date || '';
		this.state.selected_date_error = '';

		this.redirect = this.props.baseUrl;
	}

	

	componentDidMount() {
		this._ismounted = true;
		this.getTickets();
	}

	componentDidUpdate(prevProps) {
		if (prevProps.customer_address !== this.props.customer_address) {
			Call_Geocode_API(this.props.customer_address).then(response => {
				if (!response || !response?.latitude) {
					API.Toast.error(`Error getting geocoords for customer address ${this.props.customer_address}.`, {
						position: API.Toast.POSITION.TOP_CENTER,
						autoClose: 2000
					});
					return;
				}
				this.setState({
					latitude: response.latitude,
					longitude: response.longitude,
					center: {
						lat: response.latitude,
						lng: response.longitude,
					}
				});
			});
		}

		if (prevProps.customer_name !== this.props.customer_name) {
			this.setState({name: this.props.customer_name});
		}
		if (prevProps.field_engineer !== this.props.field_engineer) {
			this.setState({
				field_engineer: this.props.field_engineer,
				field_engineer_error: ''
			}, this.getTickets);
		}
	}

	getTickets = () => {
		this.model.filter = {
			field_engineer: this.state.field_engineer,
			selected_date: this.state.selected_date,
			current: this.props.id
		};

		this.model.submit(this, this.request).then((data) => {
			this.setState({
				tickets: data.items
			});
		});
	};

	handleSelectPropertyUpdate = (property, value) => {
		this.setState({
			[property]: value,
			[property + '_error']: '',
		}, this.getTickets);
	};


	handleTextFieldPropertyUpdate = (property, value) => {
		this.setState({
			[property]: value,
			[property + '_error']: '',
		}, this.getTickets);
	};

	render() {
		let zoom = 12;
		let extras = {};

		let {properties} = this.model;
		let {
			loading,
			field_engineer,
			field_engineer_error,
			field_engineers,
			selected_date,
			defaultCenter,
			latitude,
			longitude,
			name,
			center,
			tickets,
		} = this.state;

		if (center) {
			extras.center = center;
		}

		return (
			<div>
				<fieldset>
					<div style={{height: '80vh', width: '100%'}}>
						<div className="row justify-content-around">
							<div className="col-4">
								<div className="form-group">
									<Framework.Elements.Select
										shouldLoad={true}
										property={properties.field_engineer}
										value={field_engineer}
										error={field_engineer_error}
										object={field_engineers}
										update={this.handleSelectPropertyUpdate}
										text="name_first&name_last"
										nullable={true}
									/>
								</div>
							</div>
							<div className="col-4">
								<div className="form-group">
									<Framework.Elements.Date
										label="Selected Date"
										property={properties.selected_date}
										value={selected_date}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
							</div>
						</div>

						<GoogleMapReact
							bootstrapURLKeys={getGoogleMapBootstrapURLKeys()}
							defaultCenter={defaultCenter}
							defaultZoom={zoom}
							{...extras}
						>
							<PinLocation
								zoom={zoom}
								lat={latitude}
								lng={longitude}
								text={name}
							/>

							{tickets.map(
								/**
								 * @param {Tickets_Object} ticket
								 * @param i
								 */
								(ticket, i) => {

									let location = ticket.customers_locations;
									if (!location?.latitude || !location?.longitude) {
										return null;
									}
									return (
										<PinLocation
											key={i}
											zoom={zoom}
											lat={location.latitude}
											lng={location.longitude}
											text={freshdeskTicketDisplay(ticket.fresh_ticket) || ''}
										/>
									)
								}
							)}
						</GoogleMapReact>
					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	}
}
